import React from "react"
import "twin.macro"

const Blog = () => {
  return (
    <>
      {/* middle side */}
      <div tw="bg-white max-w-3xl md:col-span-5 shadow-2xl">
        <h1 tw="mt-3.5 ml-4 text-2xl font-semibold pt-8 pl-6">BLOG</h1>
        <div tw="container ">
          <p tw="p-12">
            "Brief description": Lorem ipsum dolor, sit amet consectetur
            adipisicing elit. Unde nesciunt tenetur, amet harum tempora cumque.
            Lorem ipsum dolor sit amet, consectetuer adipiscing is simply dummy
            text of the printing and typesetting industry ever since the 1500s.
          </p>
        </div>
        <div tw="container pb-6 flex items-center justify-center">
          <button tw="bg-blue-300  hover:shadow-lg  text-white font-bold py-2 px-4 rounded-full">
            check out my Blog
          </button>
        </div>
      </div>
    </>
  )
}
export default Blog
